/**
 * URL helpers — kept separate from `lib/api.js` so unit tests don't have
 * to pull in axios (which is shipped as ESM and breaks Jest's default
 * transform in CRA without extra config).
 */

/**
 * Safely join a base URL with a path, collapsing any double slashes at the
 * junction. M895 — tolerates env vars that end with `/` (e.g. Vercel UI
 * sometimes adds one) and paths that start with or without `/`.
 *
 *   joinUrl("https://api.example.com",  "/foo")  → "https://api.example.com/foo"
 *   joinUrl("https://api.example.com/", "/foo")  → "https://api.example.com/foo"
 *   joinUrl("https://api.example.com/", "foo")   → "https://api.example.com/foo"
 *   joinUrl("",                          "/foo") → "/foo"
 */
export const joinUrl = (base, path) =>
  `${String(base || "").replace(/\/+$/, "")}/${String(path || "").replace(/^\/+/, "")}`;
